import { ds24_retrieve } from "../common/ds24_retrieve";

export function ds24cart_maybe_show_msg( result: any )
{
    var msg_text = ds24_retrieve( result, 'msg_text' );
    if (!msg_text) {
        return false;
    }

    var msg_type = ds24_retrieve( result, 'msg_type' );
    var msg_display = ds24_retrieve( result, 'msg_display', 'alert' );
    const windowAny = window as any;

    if (window.DS24_ON_MESSAGE) {
        console.log( window.DS24_ON_MESSAGE, typeof window.DS24_ON_MESSAGE );
        if (typeof window.DS24_ON_MESSAGE == 'string' && typeof windowAny[ window.DS24_ON_MESSAGE ] == 'function' )
        {
            var result = windowAny[ window.DS24_ON_MESSAGE ]( msg_type, msg_text );
            return typeof result != 'undefined'
                   ? result
                   : msg_display != 'log';
        }
        else {
            console.log( 'Digistore24 cart ERROR: invalid function given for on_message: ', window.DS24_ON_MESSAGE );
        }
    }

    switch (msg_display)
    {
        case 'log':
            console.log( 'Digistore24 cart ' + msg_type.toUpperCase() + ': ' + msg_text );
            return false;

        default:
            alert(msg_text);
            return true;
    }
}
